import moment from 'moment';
import { APIService } from '../services/index'

const initState = {
  loading: false,
  textProcess: 'In processo...',
  listNote: [],
  daModificare: [],
  richiesteMensile: [],
  richiesteStatistica: [],
  listSpeseAziendale: [],
  listTarghe: [],
  listTratte: [],
  listCitta: [],
  listVia: [],
  modNota: {},
  valute: {},
  autorizzate: [],
  richiesteStatisticaDettaglio: []
}

const pageStore = {
  state: initState,
  namespaced: true,
  getters: {
    note(state) {
      return state.listNote
    },
    daModificare(state) {
      return state.daModificare
    },
    loading(state) {
      return state.loading
    },
    textProcess(state) {
      return state.textProcess
    },
    speseAziendale(state) {
      return state.listSpeseAziendale
    },
    noteGroupByDate(state) {
      var note = []
      if (state.listNote !== undefined) {
        var date = []
        const unique = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        state.listNote.forEach(function (nota) {
          if (date.indexOf(nota.data) === -1)
            date.push(nota.data)
        })
        date.forEach(function (data) {
          var obj = {
            data: data,
            items: []
          }
          var codici = state.listNote.filter(function (n) {
            return n.data === data
          }).map(function (fmap) {
            return fmap.codice
          }).filter(unique);

          codici.forEach(function (codice) {
            var note = state.listNote.filter(function (n) {
              return n.codice == codice
            })
            if (note.length > 0) {
              var item = {
                cod: codice,
                causale: note[0].causale,
                note: note,
                firma: note.filter(function (nSup) {
                  return nSup.data_firma == null
                }).length > 0 ? false : true
              }
              if (obj.items.filter(function (it) {
                return it.cod === codice
              }).length === 0)
                obj.items.push(item)
            }
          })
          note.push(obj)
        })
      }
      return note
    },
    noteNonLavorate(state, getters) {
      return getters.noteGroupByDate.filter(sp => {
        return sp.items.filter(itm => {
          return itm.note.filter(nt => {
            return [0, 3].includes(+nt.stato)
          }).length > 0
        }).length > 0
      })
    },
    targhe(state) {
      return state.listTarghe
    },
    tratte(state) {
      return state.listTratte
    },
    citta(state) {
      return state.listCitta
    },
    via(state) {
      return state.listVia
    },
    nota(state) {
      return state.modNota
    },
    valute(state) {
      return state.valute
    }
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload.state;
      state.textProcess = payload.text || initState.textProcess;
    },
    SET_SPESE_AUTORIZZATE(state, payload) {
      state.autorizzate = payload;
    },
    SET_NOTE(state, payload) {
      state.listNote = payload;
    },
    SET_NOTE_DA_MODIFICARE(state, payload) {
      state.daModificare = payload;
    },
    SET_RICHIESTE_MENSILE(state, payload) {
      state.richiesteMensile = payload;
    },
    SET_RICHIESTE_STATISTICA(state, payload) {
      state.richiesteStatistica = payload;
    },
    SET_RICHIESTE_STATISTICA_DETTAGLIO(state, payload) {
      state.richiesteStatisticaDettaglio = payload;
    },
    SET_SPESE_AZIENDALE(state, payload) {
      state.listSpeseAziendale = payload;
    },
    SET_TARGHE(state, payload) {
      state.listTarghe = payload;
    },
    SET_TRATTE(state, payload) {
      state.listTratte = payload;
    },
    SET_CITTA(state, payload) {
      state.listCitta = payload;
    },
    SET_VIA(state, payload) {
      state.listVia = payload;
    },
    SET_NOTA(state, payload) {
      state.modNota = payload;
    },
    SET_VALUTE(state, payload) {
      state.valute = payload;
    },
  },
  actions: {
    getAllNote(context) {
      return APIService.notaSpeseGetAll()
        .then(function (res) {
          if (res.stato === 'success') {
            context.commit('SET_NOTE', res.data);
          }
        })
    },
    getAllNoteDaModifica(context) {
      return APIService.notaSpeseGetDaModifica()
        .then(function (res) {
          if (res.stato === 'success') {
            context.commit('SET_NOTE_DA_MODIFICARE', res.data.note);
          }
        })
    },
    getAllRichiesteMensile(context) {
      context.commit('SET_LOADING', { state: true, text: 'Estrazione in processo...' });
      return APIService.notaSpeseGetAllRichiesteMensile()
        .then(function (res) {
          if (res.stato === 'success') {
            context.commit('SET_RICHIESTE_MENSILE', res.data.richieste);
          }
        })
        .finally(() => context.commit('SET_LOADING', { state: false }))
    },
    showStatistica(context, data) {
      context.commit('SET_LOADING', { state: true, text: 'Estrazione in processo...' });
      return APIService.notaSpeseGetStatisticaRichieste({ data })
        .then(function (res) {
          if (res.stato === 'success') {
            context.commit('SET_RICHIESTE_STATISTICA', res.data.richieste);
          }
        })
        .finally(() => context.commit('SET_LOADING', { state: false }))
    },
    showStatisticaDettaglio(context, data) {
      context.commit('SET_RICHIESTE_STATISTICA_DETTAGLIO', [])
      context.commit('SET_LOADING', { state: true, text: 'Estrazione in processo...' });
      return APIService.notaSpeseGetDettaglioRichiesteCategoria(data)
        .then((res) => {
          if (res.stato === 'success') {
            context.commit('SET_RICHIESTE_STATISTICA_DETTAGLIO', res.data);
          }
          if (res.textError) {
            this._vm.$notify({
              group: res.stato,
              text: res.textError
            })
          }
          if (res.data.length === 0) {
            this._vm.$notify({
              group: 'warning',
              text: 'Non ci sono records!'
            })
          }
          return res.stato === 'success' && res.data.length > 0
        })
        .finally(() => context.commit('SET_LOADING', { state: false }))
    },
    getAnticipoAzienda(context, data) {
      if (!data.login) {
        context.commit('SET_SPESE_AZIENDALE', []);
      } else {
        return APIService.notaSpeseGetAnticipoAzienda(data)
          .then(function (res) {
            if (res.stato === 'success') {
              context.commit('SET_SPESE_AZIENDALE', res.data);
            }
          })
      }
    },
    getSpeseAutorizzate(context, data) {
      return APIService.notaSpeseGetSpeseAutorizzate(data)
        .then((res) => {
          if (res.stato === 'success') {
            context.commit('SET_SPESE_AUTORIZZATE', res.data.richieste);
          }
        })
    },
    inviaRichiestaAutorizzazione(context, data) {
      let $that = this._vm;
      context.commit('SET_LOADING', { state: true, text: 'Modifica in processo...' });
      return APIService.inviaRichiestaAutorizzazione(data)
        .then((res) => {
          $that.$notify({
            group: res.stato,
            text: res.textError
          });
          if (res.stato === 'success') {
            context.dispatch('getSpeseAutorizzate', data);
          }
          return res.stato === 'success'
        }).finally(() => context.commit('SET_LOADING', { state: false }))
    },
    getAllTarghe(context) {
      return APIService.targaGetAll()
        .then(function (res) {
          if (res.stato === 'success') {
            context.commit('SET_TARGHE', res.data);
          }
        })
    },
    getAllTratte(context) {
      return APIService.trattaGetAll()
        .then(function (res) {
          if (res.stato === 'success') {
            context.commit('SET_TRATTE', res.data);
          }
        })
    },
    addNota(context, data) {
      let $that = this._vm;
      context.commit('SET_LOADING', { state: true, text: 'Inserimento nota...' });
      return APIService.notaSpeseAddNota(data)
        .then(function (res) {
          context.commit('SET_LOADING', { state: false });
          $that.$notify({
            group: res.stato,
            text: res.textError
          });
          return res
        })
    },
    getAllCitta(context, data) {
      return APIService.trattaGetAllCitta()
        .then(function (res) {
          if (res.stato === 'success') {
            context.commit('SET_CITTA', res.data);
          }
        })
    },
    getAllVia(context, data) {
      return APIService.trattaGetAllVia()
        .then(function (res) {
          if (res.stato === 'success') {
            context.commit('SET_VIA', res.data);
          }
        })
    },
    newTarga(context, data) {
      let $that = this._vm;
      context.commit('SET_LOADING', { state: true, text: 'Inserimento nuova targa...' });
      return APIService.targaNew(data)
        .then(function (res) {
          context.commit('SET_LOADING', { state: false });
          $that.$notify({
            group: res.stato,
            text: res.textError
          });
          if (res.stato === 'success') {
            context.dispatch('getAllTarghe');
            return true
          }
          return false
        })
    },
    newTratta(context, data) {
      let $that = this._vm;
      context.commit('SET_LOADING', { state: true, text: 'Inserimento nuova tratta...' });
      return APIService.trattaNew(data)
        .then(function (res) {
          context.commit('SET_LOADING', { state: false });
          $that.$notify({
            group: res.stato,
            text: res.textError
          });
          if (res.stato === 'success') {
            context.dispatch('getAllTratte');
            context.dispatch('getAllCitta');
            context.dispatch('getAllVia');
            return true
          }
          return false
        })
    },
    getNote(context, data) {
      let $that = this._vm;
      return APIService.getNote(data)
        .then(function (res) {
          // $that.$notify({
          //     group: res.stato,
          //     text: res.textError
          // });
          if (res.stato === 'success') {
            context.commit('SET_NOTE', res.data);
            return true
          }
          return false
        })
    },
    firmaNota(context, data) {
      let $that = this._vm;
      return APIService.firmaNota(data)
        .then(function (res) {
          $that.$notify({
            group: res.stato,
            text: res.textError
          });
          if (res.stato === 'success') {
            if (data.mese)
              context.dispatch('getNote', { data: data.mese });
            return true
          }
          return false
        })
    },
    getNota(context, data) {
      let $that = this._vm;
      return APIService.getNota(data)
        .then(function (res) {
          // $that.$notify({
          //     group: res.stato,
          //     text: res.textError
          // });
          if (res.stato === 'success') {
            var nota = {
              isAuto: res.data.isNotaAuto,
              dettaglio: res.data.dettaglio
            }
            context.commit('SET_NOTA', nota);
            return true
          }
          return false
        })
    },
    updateNota(context, data) {
      let $that = this._vm;
      context.commit('SET_LOADING', { state: true, text: 'Modifica in processo...' });
      return APIService.updateNota(data)
        .then(function (res) {
          context.commit('SET_LOADING', { state: false });
          $that.$notify({
            group: res.stato,
            text: res.textError
          });
          if (res.stato === 'success') {
            context.dispatch('getNote', { data: data.mese });
            return true
          }
          return false
        })
    },
    reinviaCodice(context, data) {
      let $that = this._vm;
      context.commit('SET_LOADING', { state: true, text: 'Invio in corso...' });
      return APIService.reinviaCodice(data)
        .then(function (res) {
          context.commit('SET_LOADING', { state: false });
          $that.$notify({
            group: res.stato,
            text: res.textError
          });
          if (res.stato === 'success') {
            return true
          }
          return false
        })
    },
    getValute(context, data) {
      let $that = this._vm;
      return APIService.getValute(data)
        .then(function (res) {
          context.commit('SET_VALUTE', res);
        })
    },
    existNota(context, data) {
      data.spese = data.spese.map(sp => {
        return { categoria: sp.categoria }
      })
      context.commit('SET_LOADING', { state: true, text: 'Verifica in corso...' });
      return APIService.existNota(data)
        .then(function (res) {
          context.commit('SET_LOADING', { state: false });
          return res
        })
    },
    removeNotaSpesa(context, data) {
      let $that = this._vm;
      context.commit('SET_LOADING', { state: true, text: 'Eliminazione in corso' });
      return APIService.removeNotaSpesa(data)
        .then(function (res) {
          context.commit('SET_LOADING', { state: false });
          $that.$notify({
            group: res.stato,
            text: res.textError
          });
          if (res.stato === 'success') {
            if (data.mese)
              context.dispatch('getNote', { data: data.mese });
            return true
          }
          return false
        })
    },
    chiudiMeseSpesa(context, data) {
      let $that = this._vm;
      context.commit('SET_LOADING', { state: true, text: 'Chiusura in corso...' });
      return APIService.chiudiMeseSpesa({ data })
        .then((res) => {
          context.commit('SET_LOADING', { state: false });
          $that.$notify({
            group: res.stato,
            text: res.textError
          });
          if (res.stato === 'success') {
            this.state.pageData.mesiChiusi = res.data.mesiChiusi
            return true
          }
          return res.stato === 'success'
        })
    }
  }
};

export default pageStore;


// WEBPACK FOOTER //
// ./modules/Home/views/src/stores/notaSpese.js